// extracted by mini-css-extract-plugin
export var childrenContainer = "_3q-0";
export var virtualScrollArea = "_3q-1";